import { ReactNode } from 'react';

type FeatureProps = {
  children?: ReactNode;
  inactiveComponent?: ReactNode;
  feature?: boolean;
};

export const Feature = ({ children, feature, inactiveComponent }: FeatureProps) => {
  return feature ? children : inactiveComponent;
};
